module.exports = __webpack_public_path__ + "static/media/video.eb4b63a2.svg";